/**
 * Classes de timeout por natureza da requisição.
 *
 * Antes disso, só 3 de ~30 call sites tinham timeout: um boot em túnel pendurava o `Promise.all`
 * do LifeCycle indefinidamente, sem erro e sem tela de erro.
 *
 * IMPORTANTE: os call sites de `dataset` precisam declarar o timeout longo **antes** de existir um
 * default curto na instância do axios. Ligar o default primeiro abortaria o download dos 25 MB de
 * `waypoints_full` (e dos `.frb`/`.fgb`) em qualquer conexão lenta.
 */
export const HTTP_TIMEOUTS = {
  /** Tiles e geocode: falha rápido, o usuário está esperando o mapa desenhar. */
  tile: 8_000,
  /** GET de tela: listas, detalhes, formulários. É o default da instância. */
  interactive: 15_000,
  /** Datasets grandes do boot: waypoints_full, .frb, .fgb, .geoz, meteorologia. */
  dataset: 60_000,
  /** Sync de metadados (cartas, geometrias). */
  sync: 30_000,
  /** Upload de arquivo processado de carta. */
  upload: 600_000
} as const
